import { useContext, useState,useEffect } from "react";
import { useNavigate, useLocation, Link, NavLink } from "react-router-dom";
import { FaSignOutAlt, FaBars, FaTimes } from "react-icons/fa";
import logo from "../Utils/Svg/Logo.svg";
import Context from "../Context/Context";
import navBarContent from "./Home/Data/Navbar";
import "./nav.css";

const NavBar = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const UserCtx = useContext(Context);
  const Navigate = useNavigate();
  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
    useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobileMenuOpen && !event.target.closest('nav')) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMobileMenuOpen]);

  return (
    <div className="h-8 sm:h-[4rem]">
      <nav className="z-50 fixed shadow-sm text-[#ffff] w-full bg-[#000000] border-b border-[#FDCF08] h-[4rem]">
        <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8 h-full">
          <div className="flex justify-between items-center h-full">
            <div className="flex-shrink-0 pl-2">
              <Link to="/" className="w-[8rem] h-[2.4rem] rounded-xl flex items-center justify-center">
                <img
                  src={logo}
                  className="relative rounded-301xl w-full p-1 h-[2rem] shrink-0 object-contain"
                  alt="Logo"
                />
              </Link>
            </div>

            <div className="hidden sm:flex items-center space-x-6 lg:space-x-8">
              {navBarContent.map((item, index) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className="relative no-underline px-3 py-2 text-sm font-semibold hover:text-[#FDCF08]"
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                  style={({ isActive }) => ({
                    color:
                      isActive || hoveredIndex === index
                        ? "#FDCF08"
                        : "#ffffff",
                  })}
                >
                  {item.label}
                </NavLink>
              ))}
              {UserCtx.isAuth ? (
                <li
                  className="flex items-center no-underline justify-center h-full bg-primaryColor cursor-pointer border-b border-#ffff overflow-hidden rounded-md py-2 px-3"
                  onClick={() => {
                    Navigate("/dashboard");
                  }}
                >
                  {UserCtx.userData?.userName?.split(" ")[0]}
                </li>
              ) : (
                <li
                  className="flex items-center justify-center h-full cursor-pointer border-b border-#ffff bg-primaryColor rounded-md py-2 px-3"
                  onClick={() => {
                    Navigate("/login");
                  }}
                >
                  Login
                </li>
              )}
            </div>

            <div className="sm:hidden">
              <button
                onClick={toggleMobileMenu}
                className="inline-flex items-center justify-center p-2 rounded-md text-white hover:text-gray-900 hover:bg-primaryColor focus:outline-none"
                aria-controls="mobile-menu"
                aria-expanded={isMobileMenuOpen}
              >
                <span className="sr-only">Open main menu</span>
                {isMobileMenuOpen ? (
                  <FaTimes className="w-4 h-4" />
                ) : (
                  <FaBars className="w-4 h-4" />
                )}
              </button>
            </div>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="sm:hidden bg-[#000] border-t border-gray-200 shadow-lg w-full">
            <div className="px-4 py-4 space-y-2 flex flex-col">
              {navBarContent.map((item, index) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block px-3 py-2 text-base font-medium rounded-md no-underline text-white hover:bg-[#FDCF08] hover:text-black"
                  style={({ isActive }) => ({
                    color: isActive ? "#FDCF08" : "#ffffff",
                  })}
                >
                  {item.label}
                </NavLink>
              ))}

              {UserCtx.isAuth ? (
                <div
                  className="block px-3 py-2 text-base font-medium text-white bg-primaryColor rounded-md cursor-pointer hover:bg-[#FDCF08] hover:text-black"
                  onClick={() => {
                    Navigate("/dashboard");
                    setIsMobileMenuOpen(false);
                  }}
                >
                  {UserCtx.userData?.userName?.split(" ")[0]}
                </div>
              ) : (
                <div
                  className="block px-3 py-2 text-base font-medium text-white bg-primaryColor rounded-md cursor-pointer hover:bg-[#FDCF08] hover:text-black"
                  onClick={() => {
                    Navigate("/login");
                    setIsMobileMenuOpen(false);
                  }}
                >
                  Login
                </div>
              )}
            </div>
          </div>
        )}
      </nav>
    </div>
  );
};

export default NavBar;